// Espejo en cliente de la regla del backend (services/appointmentEditability):
// el paciente puede cancelar o reagendar su cita SOLO antes de pagarla.
//
// El backend es quien decide de verdad; esto existe para no ofrecer un botón
// que va a fallar. Por eso replica la regla exacta, incluido el caso de la cita
// sin costo: una consulta gratuita reporta el pago como 'completed' aunque no
// haya dinero de por medio, y ahí sí se puede cambiar.

// Estados en los que la cita todavía no ha ocurrido y admite cambios.
export const EDITABLE_STATUSES = ['scheduled', 'confirmed'];

/**
 * @param {object} appointment    cita, con status y payment.amount
 * @param {string|null} paymentStatus  estado devuelto por getPaymentStatus
 *        ('completed', 'unpaid', 'pending'...). null mientras carga.
 * @returns {boolean} si mostrar los botones de cancelar/reagendar
 */
export const canPatientChangeAppointment = (appointment, paymentStatus) => {
  if (!appointment) return false;
  if (!EDITABLE_STATUSES.includes(appointment.status)) return false;

  // Aún no sabemos si está pagada: no ofrecer una acción que puede rebotar.
  if (paymentStatus === null || paymentStatus === undefined) return false;

  const amount = Number(appointment.payment?.amount ?? 0);
  const settled = paymentStatus === 'completed' && amount > 0;

  return !settled;
};
